@use "../../../../globals/bcp";

:host {
  display: block;
}

.o-logo {
  display: block;

  &__image {
    width: 100%;
    height: 100%;
    display: block;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...

/* stylelint-disable no-duplicate-selectors */
.tthidelogo {
  opacity: 0;
  pointer-events: none;
}

@include bcp.theme("buderus") {
  :host {
    height: 50px;
    width: 50px;
  }

  .o-logo {
    height: 100%;
    background-color: #002d59;
  }

  @include bcp.respond-gte(tabletl) {
    :host {
      position: absolute;
      top: 0;
      height: 162px;
      width: 162px;
    }
  }
}

@include bcp.theme("bosch") {
  .o-logo__image--large {
    width: 250%;
    height: auto;
  }
}
